import { Typography } from "@material-ui/core";
import { get } from "lodash";
import moment from "moment";
import React from "react";

const pad = (num, places) => {
	var zero = places - num.toString().length + 1;
	return Array(+(zero > 0 && zero)).join("0") + num;
};

const RangeField = ({
	record,
	source,
	basePath,
	sortable,
	sortBy,
	style = {},
	...props
}) => {
	const year = get(record, "year", 0);
	const month = get(record, "month", 0);
	if (year === 0 || month === 0) {
		return null;
	}
	const dateString = `${year}-${pad(month, 2)}-01`;
	return (
		<Typography
			variant="body2"
			{...props}
			style={{ ...style, textTransform: "capitalize" }}
		>
			{moment(dateString).format("yyyy/MM")}
		</Typography>
	);
};

export default RangeField;
